const SuspenseFallback = () => (
  <div className="flex items-center justify-center h-[70vh]">
    <span className="block border-t-4 border-red-600 rounded-full animate-spin size-24" />
  </div>
);

export default SuspenseFallback;
